import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DropdownNotification from "./dropdown/notification.jsx";
import DropdownLanguage from "./dropdown/language.jsx";
import DropdownProfile from "./dropdown/profile.jsx";
import DropdownMegaMenu from "./dropdown/mega.jsx";
import smallLogo from "../../assets/logo/logo-portrait@2x.png";
import { AppSettings } from "./../../config/app-settings.js";
import SelectInput from "./../../components/common/ui/Inputs/SelectInput";
import { masterActions } from "../../_store/master.slice.js";
import { authActions } from "../../_store/auth.slice.js";
import { facilityAction } from "../../_store/facility.slice.js";
import { managementUserAction } from "../../_store/managementUser.slice.js";
import { revenueReportingActions } from "../../_store/revenueReport.slice.js";
import { messagesAction } from "../../_store/messages.slice.js";
import { PODAction } from "../../_store/pod.slice.js";
import { kiosksActions } from "../../_store/kiosks.slice.js";
import { inmateAction } from "../../_store/inmate.slice.js";
import { photoAction } from "../../_store/photo.slice.js";
import { connectionRequestActions } from "../../_store/connectionRequest.slice.js";
import { publicUserActions } from "../../_store/publicUser.slice.js";
import { documentsActions } from "../../_store/documents.slice.js";
import { keywordAction } from "../../_store/keyword.slice.js";
import { textSearchAction } from "../../_store/textSearch.slice.js";
import { noticeAction } from "../../_store/notice.slice.js";
import { staffRequestAction } from "../../_store/staffRequest.slice.js";
import { reportingAction } from "../../_store/reporting.slice.js";
import { getStoredValue } from "../../_helpers/storagehelper.js";

function Header() {
  const dispatch = useDispatch();
  const { facilityDropDown: facilitydata } = useSelector(
    (state) => state.master
  );
  const authUser = useSelector((x) => x.auth.user);
  const facilityCode = useSelector((x) => x?.auth?.commonFacilityCode);
  const roleID = useSelector((state) => state?.auth?.user?.UserRoleID);
  const ManagementUserID = useSelector((state) => state?.auth?.user?.ManagementUserID);
  const menu_list = useSelector((state) => state?.auth?.menu_list);
  const location = useLocation();
  const pageReload = useSelector((x) => x?.master?.isPageReload);

  const staffRequestID = parseInt(process.env.REACT_APP_STAFF_REQUEST_ACCESSIBLE_FA, 10);
  const isfacilitydisabled = (roleID == 1 || ManagementUserID == staffRequestID) ? false : true;

  // Utility function to check if the ManagementMenuID is valid
  const isValidManagementMenuID = (menuID) => {
    // const validIDs = new Set([
    //   15, 1, 2, 3, 5, 6, 7, 8, 9, 10, 35, 11, 12, 13, 36, 27,
    // ]);
    // return validIDs.has(menuID);
    const currentPath = window.location.pathname;
    const values = [
      "/Admin/FacilityList",
      "/Admin/FacilityList/AddEdit",

      "/Admin/RegisteredUserList",
      "/Admin/RegisteredUserList/Edit",

      "/Admin/LogReports",

      "/Admin/MaintenanceSchedules",

      "/Admin/PostalMailList",
      "/Admin/PostalMailList/Add",
      "/Admin/PostalMailList/View",

      "/Admin/PaymentReportList",

      "/Admin/IPActivityList",

      "/Admin/support",

      "/Admin/ChangePassword",

      "/Admin/DNDUserList",
      "/Admin/DNDUserList/AddEdit",

      "/Admin/RevenueReport",

      "/Admin/E-Cards/Category",
      "/Admin/E-Cards/Category/AddOrEdit",

      "/Admin/E-Cards",
      "/Admin/E-Cards/Upload",
    ];

    const isMatch = values.some((val) => currentPath === val);

    if (isMatch) {
      return false;
    } else {
      return true;
    }
  };

  // State for dropdown visibility
  const [shouldShowSelectInput, setShouldShowSelectInput] = useState(false);

  // Effect to check the dropdown visibility when the menu changes
  useEffect(() => {
    const data = parseInt(
      document.getElementsByClassName(
        "menu-link fs-5 menu-link-custom-style active"
      )[0]?.id
    );
    setShouldShowSelectInput(isValidManagementMenuID(data));
  }, [location.pathname]); // Trigger effect on location change

  const onFacilitySelectionChange = (e) => {
    const facilityId = e && e.value ? e.value : 0; // Default to 0 if invalid
    // dispatch(masterActions.updateCommonFacilityCode(facilityId));

    dispatch(authActions?.updateCommonFacilityCode(facilityId));
    // history.navigate("PODList"); // Uncomment if needed
    const pageReloading = pageReload + 1;
    dispatch(masterActions?.updateLocation(pageReloading));

    const Userdetails = getStoredValue("user");
    const ManagementUserID =
      authUser?.ManagementUserID ?? Userdetails?.ManagementUserID ?? 0;

    dispatch(
      masterActions.GetLoadNotificationAlert({
        ManagementUserID: ManagementUserID,
        FacilityID: facilityId,
      })
    ).then((response) => {
      const updatedMenuList =
        getStoredValue("menu_list") || response?.payload;

      if (updatedMenuList) {
        dispatch(authActions.updateMenuList(updatedMenuList));
      }
    });

    const path = location?.pathname;
    switch (path) {
      case "/Admin/FacilityList":
        dispatch(facilityAction.resetFacilitySearch());
        break;

      case "/Admin/Reporting":
        dispatch(reportingAction.resetreqActivityDataSearch());
        dispatch(reportingAction.resetuserActivityDataSearch());
        break;

      case "/Admin/ManagementUserList":
      case "/Admin/ManagementUserList/Edit":
        dispatch(managementUserAction.resetManagementUserSearchData());
        break;

      case "/Admin/RevenueReport":
        dispatch(revenueReportingActions.resetRevenueReports());
        break;

      case "/Admin/MessageList":
      case "/Admin/MessageList/Conversation":
        dispatch(messagesAction.resetMessageSearchData());
        break;

      case "/Admin/PODList":
      case "/Admin/PODList/Add":
        dispatch(PODAction.resetForm());
        break;

      case "/Admin/KioskList":
      case "/Admin/KioskList/Add":
        dispatch(kiosksActions.clearKiosks());
        break;

      case "/Admin/PublicUserList":
      case "/Admin/PublicUserList/Details":
        dispatch(publicUserActions.clearpublicUserListSearch());
        break;

      case "/Admin/PhotoList":
      case "/Admin/PhotoList/info":
        dispatch(photoAction?.resetPhotoState());
        break;

      case "/Admin/DocumentList":
      case "/Admin/DocumentList/Add":
        dispatch(documentsActions.clearDocuments());
        break;

      case "/Admin/ConnectionRequestList":
        dispatch(connectionRequestActions.resetConnectionReqSearchData());
        break;

      case "/Admin/InmateList":
      case "/Admin/InmateList/Details":
        dispatch(inmateAction.resetInmateSearchData());
        break;

      case "/Admin/KeywordList":
      case "/Admin/KeywordList/AddOrEditKeyword":
        dispatch(keywordAction.clearSearchKeyword());
        break;

      case "/Admin/TextSearchList":
        dispatch(textSearchAction?.cleartextSearch());
        break;

      case "/Admin/StaffRequestList":
        dispatch(staffRequestAction?.resetStaffRequestSearcList());
        dispatch(staffRequestAction?.resetPublicDefenderSearchList());
        break;

      case "/Admin/StaffRequestList/PrivateConversation":
        dispatch(staffRequestAction?.resetPrivateConversationSearchList());
        break;

      case "/Admin/StaffRequestList/MessageToInmate":
        dispatch(staffRequestAction?.resetMessageToInmateSearchList());
        break;

      case "/Admin/NoticeList":
      case "/Admin/NoticeList/AddEdit":
        dispatch(noticeAction.resetNoticeSearch());
        break;

      default:
        break;
    }
  };

  // When Selected Facility Inactivate.Page should empty
  useEffect(() => {
    const dropdownSelected =
      Array.isArray(facilitydata) && facilitydata.length > 0
        ? facilitydata.some((item) => item?.value === facilityCode)
        : false;
    if (!dropdownSelected && facilityCode && facilitydata.length > 0) {
      dispatch(authActions?.updateCommonFacilityCode(0)); // Reset the page.
    }
  }, [facilitydata, facilityCode]);

  return (
    <AppSettings.Consumer>
      {({
        toggleAppSidebarMobile,
        toggleAppSidebarEnd,
        toggleAppSidebarEndMobile,
        toggleAppTopMenuMobile,
        appHeaderLanguageBar,
        appHeaderMegaMenu,
        appHeaderInverse,
        appSidebarTwo,
        appTopMenu,
        appSidebarNone,
        appSidebarMinify,
      }) => (
        <div
          id="header"
          className="app-header"
          data-bs-theme={appHeaderInverse ? "dark" : ""}
        >
          <div
            className={`navbar-header p-2 ${appSidebarMinify ? "minified" : ""
              }`}
          >
            {appSidebarTwo && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppSidebarEndMobile}
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            )}
            <Link
              to={
                menu_list &&
                  Array.isArray(menu_list) &&
                  menu_list.length > 0 &&
                  menu_list[0]?.ManagementMenuID !== 1000 // for avoid maintenance menu when click logo
                  ? menu_list[0].URLPath
                  : "/Admin/support"
              }
              className="text-decoration-none d-flex justify-content-between align-item-center w-100"
            >
              <img className="Sidebarlogo" src={smallLogo} alt="small-logo" />
            </Link>

            {/* <Link
              to="/Admin/FacilityList"
              className="text-decoration-none d-flex align-item-center w-100"
            >
              <img src={smallLogo} alt="small-logo" />
              <h4
                style={{
                  display: appSidebarMinify ? "none" : "",
                  marginLeft: "6px",
                  marginTop: "2px",
                }}
                className="text-white"
              >
                Inmate Inbox
              </h4>
            </Link> */}

            {appHeaderMegaMenu && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                data-bs-toggle="collapse"
                data-bs-target="#top-navbar"
              >
                <span className="fa-stack fa-lg text-inverse">
                  <i className="far fa-square fa-stack-2x"></i>
                  <i className="fa fa-cog fa-stack-1x"></i>
                </span>
              </button>
            )}
            {appTopMenu && !appSidebarNone && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppTopMenuMobile}
              >
                <span className="fa-stack fa-lg text-inverse">
                  <i className="far fa-square fa-stack-2x"></i>
                  <i className="fa fa-cog fa-stack-1x"></i>
                </span>
              </button>
            )}
            {appSidebarNone && appTopMenu && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppTopMenuMobile}
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            )}
            {!appSidebarNone && (
              <button
                type="button"
                className="navbar-mobile-toggler"
                onClick={toggleAppSidebarMobile}
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            )}
          </div>

          {appHeaderMegaMenu && <DropdownMegaMenu />}

          <div className="navbar-nav">
            {shouldShowSelectInput && (
              <div className="header-common-style d-flex flex-wrap">
                <label className="header-common-label" htmlFor="">
                  Facility Code
                </label>
                <div style={{ width: "210px" }}>
                  <SelectInput
                    name="facilityCode"
                    label=""
                    options={facilitydata}
                    value={facilityCode}
                    isMulti={false}
                    handleChange={onFacilitySelectionChange}
                    classNamePrefix={"header-facility-class"}
                    isClearable={facilityCode ? true : false}
                    isDisabled={isfacilitydisabled}
                  />
                </div>
              </div>
            )}

            {appHeaderLanguageBar && <DropdownLanguage />}
            <DropdownProfile />

            {appSidebarTwo && (
              <div className="navbar-divider d-none d-md-block"></div>
            )}

            {appSidebarTwo && (
              <div className="navbar-item d-none d-md-block">
                <Link
                  to="/"
                  onClick={toggleAppSidebarEnd}
                  className="navbar-link icon"
                >
                  <i className="fa fa-th"></i>
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
    </AppSettings.Consumer>
  );
}

export default Header;
